import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';
import { CountryLocaleEntrySchema } from './country-locale.validator';
import { LanguagesEntrySchema } from './languages.validator';

export const CountryLanguagePairEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    internalName: z.string(),
    country: CountryLocaleEntrySchema,
    languages: z.array(LanguagesEntrySchema)
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
